export default "__VITE_ASSET__CuJtXBFk__"